import React from 'react';

function Filter({fill = 'currentColor', secondaryfill, strokewidth = 1, width = '1em', height = '1em', ...props}) {
	secondaryfill = secondaryfill || fill;

	return (
		<svg height={height} width={width} {...props} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
	<g fill={fill}>
		<polygon fill="none" points="10.5 14.75 7.5 16.25 7.5 9 2.75 2.75 15.25 2.75 10.5 9 10.5 14.75" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokewidth}/>
	</g>
</svg>
	);
};

export default Filter;